import Handlebars from "handlebars-template-loader/runtime";

Handlebars.registerHelper("getMediaId", (id, internalCode) => {
  return internalCode ?? id;
});
